export default "__VITE_ASSET__4b307fbb__"